export const convertToWebP = (file: File, quality: number = 0.8): Promise<Blob> => {
  return new Promise((resolve, reject) => {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    const img = new Image();

    img.onload = () => {
      canvas.width = img.width;
      canvas.height = img.height;
      
      if (ctx) {
        ctx.drawImage(img, 0, 0);
        canvas.toBlob(
          (blob) => {
            if (blob) {
              resolve(blob);
            } else {
              reject(new Error('WebP conversion failed'));
            }
          },
          'image/webp',
          quality
        );
      } else {
        reject(new Error('Canvas context not available'));
      }
    };

    img.onerror = () => reject(new Error('Image loading failed'));
    img.src = URL.createObjectURL(file);
  });
};

export const supportsWebP = (): Promise<boolean> => {
  return new Promise((resolve) => {
    const webP = new Image();
    webP.onload = webP.onerror = () => {
      resolve(webP.height === 2);
    };
    webP.src = 'data:image/webp;base64,UklGRjoAAABXRUJQVlA4IC4AAACyAgCdASoCAAIALmk0mk0iIiIiIgBoSygABc6WWgAA/veff/0PP8bA//LwYAAA';
  });
};

export const getOptimizedImageSrc = (originalSrc: string, fallbackSrc?: string): string => {
  if (originalSrc.includes('.webp')) {
    return originalSrc;
  }
  
  // For URLs with query params (like Supabase Storage), replace the extension before the query params
  if (originalSrc.includes('?')) {
    const [path, queryString] = originalSrc.split('?');
    const webpPath = path.replace(/\.(png|jpg|jpeg)$/i, '.webp');
    return `${webpPath}?${queryString}`;
  }
  
  const webpSrc = originalSrc.replace(/\.(png|jpg|jpeg)$/i, '.webp');
  return webpSrc;
};

export const downloadWebP = (blob: Blob, filename: string) => {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename.replace(/\.(png|jpg|jpeg)$/i, '.webp');
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};